import React from 'react';

import PageHeader from '@atlaskit/page-header';

import { HelpPanelOpenButton } from '@qality/common-components/src/molecules/HelpPanelOpenButton';
import { OnboardingPlaylist } from '@qality/common-components/src/onboarding/OnboardingPlaylist';

import { PageHeaderWrapper, PageWrapperStyled } from './Dashboard.styled';
import { DashboardActions } from './DashboardComponents/DashboardActions';
import { DashboardBreadcrumbs } from './DashboardComponents/DashboardBreadcrumbs';
import Gadgets from './Gadgets';

interface DashboardViewProps {
  project: any;
  projectKey: string;
  projectId: string;
  projectName: string;
  isQAlityConfigured: boolean;
  nameSuffix: string;
}

export const DashboardView: React.FC<DashboardViewProps> = ({
  project,
  projectKey,
  projectId,
  projectName,
  isQAlityConfigured,
  nameSuffix,
}: DashboardViewProps) => {
  const breadcrumbs = (
    <DashboardBreadcrumbs
      projectKey={projectKey}
      projectId={projectId}
      projectName={projectName}
      nameSuffix={nameSuffix}
    />
  );

  const actionsContent = isQAlityConfigured ? (
    <DashboardActions
      project={project}
      projectName={projectName}
      nameSuffix={nameSuffix}
    />
  ) : (
    <HelpPanelOpenButton />
  );

  return (
    <div>
      <PageWrapperStyled>
        <PageHeaderWrapper>
          <PageHeader breadcrumbs={breadcrumbs} actions={actionsContent}>
            QAlity {nameSuffix} Dashboard
          </PageHeader>
        </PageHeaderWrapper>
        <OnboardingPlaylist />
        <Gadgets />
      </PageWrapperStyled>
    </div>
  );
};
